import styled, { css } from 'styled-components'
import { themeGet } from 'styled-system'

export const PreviewCourseLinksList = styled.ul`
  list-style-type: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-wrap: wrap;
  gap: 1.25rem;
  padding-top: 0.5rem;
  margin-bottom: 0.5rem;

  li {
    display: inline-block;
    margin: 0;
    flex: 0 0 auto;
  }

  button {
    min-width: 12rem;
    height: 3rem;
    border-radius: 0.5rem;
    border: none;
    font-weight: 600;
    background-color: ${themeGet(
      'colors.buttons.productPreviewBackground',
      themeGet('colors.themePrimary'),
    )};
    color: ${themeGet('colors.white')};
    width: auto;
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  button:hover {
    background-color: ${themeGet('colors.themeHighlight')};
  }

  ${({ $tier }) =>
    $tier === 1 &&
    css`
      button {
        min-width: 6.875rem;
      }
    `}

  ${({ $tier }) =>
    $tier === 2 &&
    css`
      button {
        min-width: 8rem;
      }
    `}

  ${({ $isDigitalWellBeing }) =>
    $isDigitalWellBeing &&
    css`
      align-items: flex-start;
      flex-direction: column;
      gap: 1rem;
      padding-top: 0;

      button {
        background-color: ${themeGet(
          'colors.buttons.productPreviewBackground',
          themeGet('colors.themePrimary'),
        )};
        min-width: 6.5rem;
      }

      button:hover {
        background-color: ${themeGet('colors.themeHighlight')};
      }
    `}
`

export const GradeSection = styled.li`
  display: block;
  flex: 0 0 auto;

  & h3 {
    font-family: ${themeGet('font.sharpSlab.semibold', 'SharpSlab-Semibold')};
    font-weight: 600;
    font-size: 1.125rem;
    line-height: 1;
    margin: 0 0 0.5rem;
  }
`

export const GradeCourseLinks = styled.ul`
  display: flex;
  flex-wrap: wrap;
  gap: 1.25rem;
  list-style-type: none;
  margin: 0;
  padding: 0;
`
